import React from 'react';
import TextRenderType from '../text';
export var NUMBER_TYPE_TEST_ID = 'link-datasource-render-type--number';
var NumberRenderType = function NumberRenderType(_ref) {
  var number = _ref.number,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? NUMBER_TYPE_TEST_ID : _ref$testId;
  if (typeof number !== 'number') {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  var formattedNumber = number.toLocaleString(undefined, {
    maximumFractionDigits: 15
  });
  return /*#__PURE__*/React.createElement(TextRenderType, {
    testId: testId,
    text: formattedNumber
  });
};
export default NumberRenderType;